import React from 'react';
import { number } from 'prop-types';
import classNames from 'classnames';
import { LuImage } from 'react-icons/lu';
import { FormattedMessage } from '../../util/reactIntl';
import { createSlug } from '../../util/urlHelpers';
import { propTypes } from '../../util/types';
import { getCardPrice } from '../../util/listingPackages';
import { NamedLink, PackagePrice, ResponsiveImage } from '../../components';

import css from './ServiceCard.css';

// Scaled variants keep the uploaded 16:9 crop; the cover crops with object-fit.
const COVER_VARIANTS = ['scaled-small', 'scaled-medium', 'scaled-large'];
const COVER_SIZES = '(max-width: 767px) 100vw, (max-width: 1023px) 50vw, 267px';

// DS "Service page / Service card" 317:1947: the cover (or the placeholder tint
// and image icon), the title and "from {price}" pinned to the bottom. The price
// is package 1's, with its unit.
const ServiceCard = props => {
  const { listing, placeholderIndex } = props;
  const { title = '' } = listing.attributes;
  const cover = listing.images && listing.images.length > 0 ? listing.images[0] : null;

  const cardPrice = getCardPrice(listing);

  return (
    <NamedLink
      className={css.root}
      name="ListingPage"
      params={{ id: listing.id.uuid, slug: createSlug(title) }}
    >
      <span className={classNames(css.cover, { [css.coverAltTint]: placeholderIndex % 2 === 1 })}>
        {cover ? (
          <ResponsiveImage
            rootClassName={css.coverImage}
            alt=""
            image={cover}
            variants={COVER_VARIANTS}
            sizes={COVER_SIZES}
          />
        ) : (
          <LuImage className={css.placeholderIcon} aria-hidden="true" />
        )}
      </span>
      <span className={css.body}>
        <span className={css.title}>{title}</span>
        {cardPrice ? (
          <span className={css.priceRow}>
            <span className={css.from}>
              <FormattedMessage id="ServiceCard.from" />
            </span>
            <PackagePrice
              className={css.price}
              price={cardPrice.price}
              pricingModel={cardPrice.pricingModel}
            />
          </span>
        ) : null}
      </span>
    </NamedLink>
  );
};

ServiceCard.defaultProps = {
  placeholderIndex: 0,
};

ServiceCard.propTypes = {
  listing: propTypes.listing.isRequired,
  // Every second card without a cover gets the green placeholder tint (Figma).
  placeholderIndex: number,
};

export default ServiceCard;
